/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CouponProductChangeDto } from './couponProductChangeDto';

export interface CouponPriceChangeDto {
  couponId?: number;
  couponPriceChangeId?: number;
  couponType?: number;
  dateChange?: Date;
  enabled?: boolean;
  freebieMessage?: string;
  productVariantSubscriptionTypeIds?: Array<number>;
  productVariants?: Array<CouponProductChangeDto>;
  subscriptionTypeIds?: Array<number>;
  value?: number;
}
